module.exports = __webpack_public_path__ + "tables/media/Documentation_outlined.f9483997.svg";